import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { getApiConfig } from '../../config/api'

export const apiSlice = createApi({
  reducerPath: 'api',
  baseQuery: fetchBaseQuery({
    baseUrl: getApiConfig().apiEndpoint,
    prepareHeaders: (headers) => {
      // Add auth token here when implemented
      return headers
    },
  }),
  tagTypes: ['Health', 'User', 'Market'],
  endpoints: (builder) => ({
    getHealth: builder.query({
      query: () => '/health',
      providesTags: ['Health'],
    }),
  }),
})

export const { useGetHealthQuery } = apiSlice